function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5919 12.0002L20.6702 4.92162C21.1099 4.48221 21.1099 3.76925 20.6702 3.32984C20.2304 2.89005 19.5182 2.89005 19.0785 3.32984L12.0002 10.4084L4.92154 3.32984C4.48177 2.89005 3.76959 2.89005 3.32982 3.32984C2.89006 3.76925 2.89006 4.48221 3.32982 4.92162L10.4085 12.0002L3.32982 19.0788C2.89006 19.5182 2.89006 20.2311 3.32982 20.6705C3.54971 20.8901 3.83788 21 4.12568 21C4.41348 21 4.70165 20.8901 4.92154 20.6702L12.0002 13.5916L19.0785 20.6702C19.2983 20.8901 19.5865 21 19.8743 21C20.1621 21 20.4503 20.8901 20.6702 20.6702C21.1099 20.2308 21.1099 19.5178 20.6702 19.0784L13.5919 12.0002Z",
  fill: "#878793"
});

function SvgIconClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClose);
export default __webpack_public_path__ + "static/media/icon-close.cc0fc59e.svg";
export { ForwardRef as ReactComponent };